type GetOptionStateParams = {
  option: string;
  disabledTimes: string[];
  selectedTime: string;
};

export const getOptionState = ({
  option,
  disabledTimes,
  selectedTime,
}: GetOptionStateParams) => {
  if (disabledTimes.includes(option)) return 'disabled';
  if (selectedTime === option) return 'selected';

  return 'default';
};
